// BMRTable.js
import React, { useState } from 'react';
function BMRTable({ formula,bmr, Sedentary, Exercise1_3, Exercise4_5, DailyExercise, IntenseExercise, VeryIntenseExercise}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Total Kebutuhan Kalori Harian:</th>
          <th > Kalori (per hari)</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Kurang gerak (sedikit atau tidak olahraga)</td>
          <td>{Sedentary}  </td>
        </tr>
        <tr >
          <td>Olahraga / olahraga 1-3 hari per minggu  </td>
          <td>{Exercise1_3}  </td>
        </tr>
        <tr >
          <td>Olahraga / olahraga 4-5 hari per minggu</td>
          <td>{Exercise4_5}  </td>
        </tr>
        <tr >
        <td>
Olahraga harian atau olahraga intens 3-4 kali / minggu
           </td>
          <td>{DailyExercise}  </td>
        </tr>
        <tr >
          <td>Olahraga berat / olahraga 6-7 hari per minggu</td>
          <td>{IntenseExercise}  </td>
        </tr>
        <tr >
          <td>
          Olahraga sangat intens setiap hari, atau pekerjaan fisik
           </td>
          <td>{VeryIntenseExercise}  </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMRTable;